<app-admin-custom-control [label]="label" [centerLabel]="centerLabel" [labelCols]="labelCols"
  [dividerKind]="dividerKind" [disabled]="disabled">
  <div class="input-group">
    <input type="text" [id]="'input'+uniqueId" [appFocus]="focusInput" class="form-control" [disabled]="disabled"
      [(ngModel)]="model" (ngModelChange)="modelChange.emit(model)" (click)="clickModel($event)"
      [placeholder]="placeholder?placeholder:''" autocomplete="off" [uppercase]="toUppercase"
      [appSelectOnclick]="selectOnclick">
    <ng-content></ng-content>
  </div>
</app-admin-custom-control>